import * as CONST from 'Reducers/UIBlock/const'

const initState = {
  uiBlockEnabled: false,
}

export function uiBlock(state = initState, action) {
  switch (action.type) {
    case CONST.ENABLE_UI_BLOCK:
      return {
        ...state,
        uiBlockEnabled: true,
      }

    case CONST.DISABLE_UI_BLOCK:
      return {
        ...state,
        uiBlockEnabled: false,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/UIBlock/reducer.js